module.exports = __webpack_public_path__ + "static/media/secietypic02@2x.6b627f94.png";